var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("BarreFiltres", {
        attrs: { filtres: _vm.filtres },
        on: {
          "appliquer-filtre": function($event) {
            return _vm.appliquerFiltre($event)
          }
        }
      }),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-center-center" }, [
      _c(
        "div",
        { staticClass: "card col-12 col-xl-10 col-xxl-8 height-responsive" },
        [
          _c("div", { staticClass: "card-header" }, [
            _vm._v("Fournisseurs - Documentation")
          ]),
          _c(
            "div",
            {
              staticClass:
                "card-container height-responsive-body height-responsive-1b"
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("section", [
                  _c("p", [
                    _vm._v(
                      "La configuration des fournisseurs est essentielle au bon fonctionnement de Mercudyn. "
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Sans cela, le logiciel ne saura pas quand vous livrer et optimiser vos commandes."
                    )
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionActivation" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Activation ")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      'Le sous-menu "activation" vous offre la possibilité, par famille de produits et par fournisseur, de gérer vos mercuriales en activant ou désactivant les fournisseurs pour lesquels vous ne commandez pas de produits.'
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/fournisseurs/fournisseurVueParFamille.png"),
                        alt: "Illustration vue par famille fournisseurs"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Dans cette vue, un code couleur supplémentaire est visible, le gris. Il signifie que le fournisseur est désactivé dans cette famille de produit"
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Via un simple clic sur un fournisseur, un menu permet diverses actions."
                    )
                  ]),
                  _c("div", { staticClass: "flex-center-center mb-3" }, [
                    _c("div", { staticClass: "col-4" }, [
                      _c("img", {
                        staticClass: "border-black border-rounded w-100",
                        attrs: {
                          src: require("../../assets/images/documentation/fournisseurs/fournisseursSousMenu.png"),
                          alt: "Illustration du sous-menu d'un fournisseur"
                        }
                      })
                    ])
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _c("span", { staticClass: "bold600" }, [
                        _vm._v("Activer/Desactiver")
                      ]),
                      _vm._v(
                        ": Active ou désactive le fournisseur pour cette famille de produits."
                      )
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "bold600" }, [
                        _vm._v("Activer uniquement ce fournisseur ")
                      ]),
                      _vm._v(
                        ": Fait en sorte que seul ce fournisseur soit activé pour cette famille de produits."
                      )
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "bold600" }, [
                        _vm._v("Activer tous les fournisseurs ")
                      ]),
                      _vm._v(
                        ": Active tous les fournisseurs disponibles pour cette famille de produits."
                      )
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "bold600" }, [
                        _vm._v(
                          "Activer ce fournisseur pour toutes les familles "
                        )
                      ]),
                      _vm._v(
                        ": Active ce fournisseur dans toutes les familles de produits pour lesquelles il est listé."
                      )
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "bold600" }, [
                        _vm._v(
                          "Désactiver ce fournisseur pour toutes les familles "
                        )
                      ]),
                      _vm._v(
                        ": Désactive ce fournisseur dans toutes les familles de produits pour lesquelles il est listé."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "h6 important" }, [
                    _vm._v(
                      " Les produits d'un fournisseur dans une famille ne sont affichés et commandables que si celui-ci est actif dans la famille de produits concernée. "
                    )
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionConfiguration" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Configuration")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      'Le sous menu "configuration" affiche un résumé des fournisseurs actifs sur l\'établissement. '
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Un code couleur est là pour avertir de l'état du fournisseur. "
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _c(
                        "span",
                        { staticClass: "bg-primary p-1 border-rounded" },
                        [_vm._v("Bleu")]
                      ),
                      _vm._v(
                        ", le fournisseur est suffisamment configuré pour permettre la commande de produits."
                      )
                    ]),
                    _c("li", [
                      _c(
                        "span",
                        { staticClass: "bg-error p-1 border-rounded" },
                        [_vm._v("Rouge")]
                      ),
                      _vm._v(
                        ", le fournisseur n'est pas bien configuré. Il peut manquer les jours de livraison et/ou la sélection du dépôt livrant l'établissement si plusieurs sont possibles."
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/fournisseurs/fournisseursVueGeneral.png"),
                        alt: "Illustration vue générale fournisseurs"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Dans cette illustration nous pouvons noter les problèmes suivants : Les fournisseurs 4 et 6 sont en rouge ce qui indique un problème."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Pour le 4 et le 6 il manque les dates de livraison. Le fournisseur 6 n'a pas non plus de dépôt de renseigné."
                    )
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionEditerFournisseur" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Editer un fournisseur")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "Cliquer sur un fournisseur permet d'éditer ses données et corriger un éventuel problème."
                    )
                  ]),
                  _c("div", { staticClass: "flex-center-center mb-3" }, [
                    _c("div", { staticClass: "col-4" }, [
                      _c("img", {
                        staticClass: "border-black border-rounded w-100",
                        attrs: {
                          src: require("../../assets/images/documentation/fournisseurs/fournisseurEdition.png"),
                          alt: "Illustration de l'édition d'un fournisseur"
                        }
                      })
                    ])
                  ]),
                  _c("p", [
                    _vm._v(
                      "Si plusieurs dépôts livrent votre département, il faudra sélectionner celui qui livre votre établissement. "
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Remplissez les champs que vous jugez utiles et sélectionnez les jours de livraison du fournisseur pour votre établissement."
                    )
                  ]),
                  _c("div", { staticClass: "h6 important" }, [
                    _c("p", [
                      _vm._v(
                        "Le dépôt vous livrant et les jours de livraison dépendent directement de vos fournisseurs. "
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        " Il nous est impossible de pré remplir pour vous ces informations."
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "Si une adresse email est ajoutée à la fiche fournisseur, elle servira de destinataire pour les commandes par email et activera cette fonctionnalité."
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }